import { Dialog, Box, Button } from "@mui/material";
import { buildInvoiceHTML } from "./Invoicetemplate";

const InvoicePopup = ({ open, onClose, data }) => {
  if (!data) return null;

  const getInvoiceHTML = (forPrint = false) => buildInvoiceHTML(data, forPrint);

  // ── print handler ────────────────────────────────────────────────────────
  const handlePrint = () => {
    const win = window.open("", "", "width=1100,height=900");
    win.document.write(`
      <html>
        <head>
          <title>Tax Invoice - ${data.invoice.invoiceNo}</title>
          <style>
            @page { size: A4; margin: 8mm 10mm; }
            html, body { margin: 0; padding: 0; background: #fff; width: 100%; }
            *     { box-sizing: border-box; }
            img   { max-width: 100%; }
            table { page-break-inside: avoid; break-inside: avoid; }
          </style>
        </head>
        <body>
          ${getInvoiceHTML(true)}
          <scr` + `ipt>
            window.onload = function() {
              window.print();
              window.onafterprint = function() { window.close(); };
            };
          </scr` + `ipt>
        </body>
      </html>
    `);
    win.document.close();
  };

  // ── render ────────────────────────────────────────────────────────────────
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2, bgcolor: "#d4d4d4" } }}
    >
      <Box sx={{ p: 1.5, bgcolor: "#d4d4d4" }}>

        {/* toolbar */}
        <Box display="flex" justifyContent="flex-end" alignItems="center" mb={1.5} gap={1}>
          <Button
            variant="contained"
            onClick={handlePrint}
            sx={{ bgcolor: "#0d1b2a", borderRadius: 2, fontWeight: 700, "&:hover": { bgcolor: "#1a3a5c" } }}
          >
            🖨️ Print / Save PDF
          </Button>
          <Button variant="outlined" onClick={onClose} sx={{ borderRadius: 2, fontWeight: 700 }}>
            Close
          </Button>
        </Box>

        {/* preview */}
        <Box
          sx={{ bgcolor: "#fff", borderRadius: 1, overflow: "auto" }}
          dangerouslySetInnerHTML={{ __html: getInvoiceHTML(false) }}
        />

      </Box>
    </Dialog>
  );
};

export default InvoicePopup;